import { Box, Typography, Paper } from "@mui/material";
import VirtualizedTable from '../../components/common/VirtualizedTable';

const CriteriaAnalyticsTable = ({ data, loading, name='Аналитика по критериям' }) => {
  
  // Подготовка данных для таблицы
  const criteriaData = data.reduce((acc, item) => {
    // Проходим по каждому критерию в оценке
    item.assessment.items.forEach(criteriaItem => {
      const { criteria_name, score, positive } = criteriaItem;
      
      // Если ключа для критерия еще нет, создаем его
      if (!acc[criteria_name]) {
        acc[criteria_name] = {
          errorCount: 0,      // Количество ошибок
          deductedScore: 0,   // Сумма снятых баллов
          total: 0            // Количество проверок
        };
      }
      
      // Увеличиваем счетчик проверок для этого критерия
      acc[criteria_name].total += 1;
      
      // Рассчитываем значение для проверки
      let checkValue = positive ? score : (1 - score);
      let errorValue = positive ? (1 - score) : score;
      
      // Если значение < 1 — это неидеальная оценка, считаем как ошибку
      if (checkValue < 1) {
        acc[criteria_name].errorCount += 1;
        acc[criteria_name].deductedScore += errorValue;
      }
    });
    
    return acc;
  }, {});
  
  // console.log('CriteriaAnalyticsTable processed data:', criteriaData);

  // Преобразование в массив для таблицы
  const rows = Object.entries(criteriaData)
    .map(([criteria_name, dataObj]) => ({
      id: criteria_name,
      criteria_name,
      errorCount: dataObj.errorCount,
      deductedScore: dataObj.deductedScore,
      total: dataObj.total
    }))
    .sort((a, b) => b.errorCount - a.errorCount); // Сортировка по убыванию ошибок

  const columns = [
    {
      accessorKey: 'criteria_name',
      header: 'Название критерия',
      size: 300,
      enableSorting: true,
    },
    {
      accessorKey: 'errorCount',
      header: 'Количество ошибок в критерии',
      size: 180,
      enableSorting: true,
    },
    {
      accessorKey: 'deductedScore',
      header: 'Сумма снятых баллов',
      size: 180,
      enableSorting: true,
      cell: info => info.getValue().toFixed(1),
    },
    {
      accessorKey: 'total',
      header: 'Количество проверок',
      size: 120,
      enableSorting: true,
    },
  ];

  return (
      <>
        {data.length > 0 && (
          <Box sx={{ height: '100%', width: '100%', mt: 4 }}>
            <Paper sx={{ p: 2, height: '100%', width: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Анализ по критериям
              </Typography>
              <VirtualizedTable
                data={rows}
                columns={columns}
                pageSize={10}
                noDataText="Нет данных для отображения"
                tableName={name}
                frozenColumnCount={0}
              />
            </Paper>
          </Box>
        )}

        {!data.length && !loading && (
          <Typography variant="body1" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
            Нет данных для отображения аналитики
          </Typography>
        )}
      </>
  );
};

export default CriteriaAnalyticsTable;
